import { styled } from 'solid-styled-components';
import { StyledCommonA4Body, StyledCommonFittingTemplate } from '../shared-components.style';
import { pdfStore } from '../../../pdf-store';

const eventRightPadding = 125;

const StyledEventBody = styled.div`
    padding-right: ${eventRightPadding}px;
`;

export const EventA4Body = (props: any) => {
    return (
        <StyledCommonA4Body debugging={pdfStore.debugging}>
            <StyledEventBody>
                {props.children}
            </StyledEventBody>
        </StyledCommonA4Body>
    );
};





const StyledEventFittingTemplate = styled.div`
    padding-right: ${eventRightPadding}px;
`;

export const EventFittingTemplate = (props: any) => {
    return (
        <StyledCommonFittingTemplate debugging={pdfStore.debugging}>
            <StyledEventFittingTemplate>
                {props.children}
            </StyledEventFittingTemplate>
        </StyledCommonFittingTemplate>
    );
};
